export const TeamChatMessageInputTestIds = {
  ATTACH_BUTTON: 'team-chat.message-attach-button',
  SHARE_VIEW_BUTTON: 'team-chat.message-share-view-button',
  MESSAGE_INPUT: 'team-chat.message-input',
  SEND_BUTTON: 'team-chat.message-send-button',
};
